'use strict';

function PerformanceReviewInviteController(salaryService, contactService, $location, $q) {
  var vm = this;

  vm.$onInit = $onInit;
  vm.upload = upload;
  vm.excludeEmployee = excludeEmployee;
  vm.postInvitations = postInvitations;

  function $onInit() {
    vm.imported = [];
    vm.postImport = { valid: [], invalid: [] };
    vm.visibility = { file: true, table: false };
    vm.unwind = salaryService.urls.invite.base({ round: vm.round });
  }

  function upload(csv) {
    contactService.listContacts()
      .then(function(response) {
        if(response.data.length > 0) {
          var promises = response.data.map(function(contact) {
            return contactService.deleteContact(contact);
          });
          $q.all(promises).then(function(){
            return _upload(csv);
          });
        } else {
          return _upload(csv);
        }
      });
  }

  function excludeEmployee(index) {
    vm.imported.splice(index, 1);
  }

  function _upload(csv) {
    return contactService.contactCsvImport(csv)
      .then(function(response) {
        vm.badFile = false;
        vm.badRows =  [];
        if (response.data.bad_rows.length > 0) {
          vm.badRows = response.data.bad_rows;
          return response;
        }
        else {
          var promises = response.data.contacts.map(function(contact) {
            return contactService.createContact(contact.contact, false);
          });
          $q.all(promises).then(function(){
            $location.url(vm.unwind);
          });
        }
        return response;
      })
      .catch(function() {
        vm.badFile = true;
        vm.badRows =  [];
      });
  }

  function postInvitations() {

  }
}

module.exports = PerformanceReviewInviteController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite-import/salary-invite-import.controller.js
 ** module id = 203
 ** module chunks = 0
 **/